import { Waves, Ship, Sailboat, Sparkles, Wine, Baby } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { ACTIVITIES } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

const ICONS = { Waves, Ship, Sailboat, Sparkles, Wine, Baby };

export const Activities = () => {
  const { t } = useLang();
  return (
    <section
      id="activities"
      data-testid="activities-section"
      className="py-24 md:py-36 bg-background"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-14">
          <Reveal className="max-w-2xl">
            <Eyebrow>{t.activities.eyebrow}</Eyebrow>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-5 leading-tight">
              {t.activities.title}
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {ACTIVITIES.map((a, i) => {
            const Icon = ICONS[a.icon] || Waves;
            const item = t.activities.items[i] || a;
            return (
              <Reveal key={i} delay={(i % 3) * 0.1} className="group">
                <div
                  data-testid={`activity-card-${i}`}
                  className="overflow-hidden relative"
                >
                  <img
                    src={a.img}
                    alt={`${item.title} at Tribe Beach Lounge, Tigaki, Kos`}
                    className="w-full h-[300px] md:h-[340px] object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground/70 via-foreground/10 to-transparent" />
                  <div className="absolute top-5 left-5 w-11 h-11 bg-background/90 flex items-center justify-center">
                    <Icon size={20} className="text-primary" />
                  </div>
                  <h3 className="absolute bottom-5 left-5 right-5 font-serif text-2xl md:text-3xl text-white">
                    {item.title}
                  </h3>
                </div>
                <p className="mt-4 text-muted-foreground font-light leading-relaxed">
                  {item.desc}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
